var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ic_call_24px",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#ic_call_24px)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_call_24px-2",
    "data-name": "ic_call_24px",
    d: "M9.033,15.983A25.248,25.248,0,0,0,20.017,26.967L23.683,23.3a1.657,1.657,0,0,1,1.7-.4,19.012,19.012,0,0,0,5.95.95A1.672,1.672,0,0,1,33,25.517v5.817A1.672,1.672,0,0,1,31.333,33,28.331,28.331,0,0,1,3,4.667,1.672,1.672,0,0,1,4.667,3H10.5a1.672,1.672,0,0,1,1.667,1.667,18.934,18.934,0,0,0,.95,5.95,1.673,1.673,0,0,1-.417,1.7Z",
    transform: "translate(6 3)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.11adac427f5b8d229eee922ef437c6c0.svg";
export { ForwardRef as ReactComponent };